import Transform from "@ember-data/serializer/transform";
import ConsultationAllowedType from "core/models/consultation/consultation-allowed-type";
export default class ConsultationAllowedTypesTransform extends Transform {
  deserialize(serialized) {
    return serialized.map(item => {
      const provider = {
        specialtySourceValue: item["provider"]["specialty-source-value"],
        specialtySourceLabel: item["provider"]["specialty-source-label"]
      };
      const procedure = {
        sourceValue: item["procedure"]["source-value"],
        sourceLabel: item["procedure"]["source-label"]
      };
      return new ConsultationAllowedType(item["id"], item["enabled"], provider, procedure);
    });
  }
  serialize(deserialized) {
    return deserialized.map(item => {
      const provider = {
        "specialty-source-value": item.provider.specialtySourceValue,
        "specialty-source-label": item.provider.specialtySourceLabel
      };
      const procedure = {
        "source-value": item.procedure.sourceValue,
        "source-label": item.procedure.sourceLabel
      };
      return {
        id: item.id,
        enabled: item.enabled,
        provider,
        procedure
      };
    });
  }
}